import { DirectiveOptions } from "vue";

const toUpperCase = (el: HTMLInputElement): void => {
  const sourceValue = el.value;
  const newValue = sourceValue.toUpperCase();

  if (sourceValue !== newValue) {
    el.value = newValue;
    el.dispatchEvent(new Event("input", { bubbles: true }));
  }
};

const directive: DirectiveOptions = {
  update(el) {
    // Handle any input
    if (el instanceof HTMLInputElement) {
      toUpperCase(el);
      return;
    }

    // Handle Input of Ant Design
    if (el.tagName.toLowerCase() == "span" && el.className.includes("ant-input")) {
      for (let index = 0; index < el.childNodes.length; index++) {
        const node = el.childNodes[index];

        if (node instanceof HTMLInputElement) {
          toUpperCase(node);
          break;
        }
      }
    }

    // if (el.firstElementChild && el.firstElementChild instanceof HTMLInputElement) {
    //   toUpperCase(el.firstElementChild);
    // }
  }
};

export default directive;
